import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=28c3bf75&scoped=true&"
import script from "./maintenance.vue?vue&type=script&lang=js&"
export * from "./maintenance.vue?vue&type=script&lang=js&"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=28c3bf75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3bf75",
  null
  
)

export default component.exports